import { Box } from "@mui/material";
import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { CMForm } from "../../components/common/Form/CMForm";
import { PageHeader } from '../../components/common/PageHeader/PageHeader';
import { addPatient } from "./PatientServices";
import { validationSchema, formFields } from "./PatientSchema";
import PatientTable from "./PatientTable/PatientTable";

export const PatientAdd = () => {

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row>
                        <Col lg={12}>
                            <Box component="div" sx={{ mt: 2 }}>
                                <PageHeader header="Add Patient" />
                            {/* <CMForm
                                validationSchema={validationSchema}
                                formFields={formFields}
                                addService={addPatient}
                                listPageKey='PATIENT_LIST'
                            /> */}
                                <PatientTable/>
                            </Box>
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    )
}
